import { AirPlayButton as AirPlayButton$1 } from "../../../../../ui/airplay-button/component.js";
import ForwardRef from "../../../../../icons/dist/react/minimal/airplay-enter.js";
import ForwardRef$1 from "../../../../../icons/dist/react/minimal/airplay-exit.js";
import { Button } from "../../../shared/components/buttons/button.js";
import { jsx, jsxs } from "react/jsx-runtime";
import { cn, resolveClassName } from "@videojs/utils/style";
//#region src/internal/skins/minimal-video/components/buttons/airplay-button.tsx
/** @jsxImportSource react */
function AirPlayButton({ className, ...props } = {}) {
	return /* @__PURE__ */ jsxs(AirPlayButton$1, {
		render: /* @__PURE__ */ jsx(Button, {}),
		className: (state) => cn("media-airplay-button", resolveClassName(className, state)),
		...props,
		children: [/* @__PURE__ */ jsx(ForwardRef, { className: cn("media-button-icon", "media-airplay-button-enter-icon") }), /* @__PURE__ */ jsx(ForwardRef$1, { className: cn("media-button-icon", "media-airplay-button-exit-icon") })]
	});
}
//#endregion
export { AirPlayButton };

//# sourceMappingURL=airplay-button.js.map